/** Talking to the server. Errors carry the server's plain-English message. */
export class ApiError extends Error {
  constructor(public status: number, message: string, public data: Record<string, unknown>) { super(message); }
}

/** The phone Store tab marks its requests so changes are recorded as "<name> (phone)". */
let VIA: string | null = null;
export function setVia(v: string | null) { VIA = v; }

export async function api<T = Record<string, unknown>>(method: string, path: string, body?: unknown): Promise<T> {
  const headers: Record<string, string> = body === undefined ? {} : { 'content-type': 'application/json' };
  if (VIA) headers['x-mw-via'] = VIA;
  const r = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  let data: Record<string, unknown> = {};
  try { data = await r.json(); } catch { /* empty */ }
  if (!r.ok) throw new ApiError(r.status, String(data.error ?? 'Something went wrong. Try again.'), data);
  return data as T;
}

export const get = <T,>(p: string) => api<T>('GET', p);
export const post = <T,>(p: string, b: unknown = {}) => api<T>('POST', p, b);
export const patch = <T,>(p: string, b: unknown) => api<T>('PATCH', p, b);
export const put = <T,>(p: string, b: unknown) => api<T>('PUT', p, b);

export type Role = 'admin' | 'hr' | 'manager' | 'lead' | 'employee';
export interface Me {
  name: string; firstName: string; role: Role; level: number | null; employeeId: number | null;
  homeLocationId: number | null; locationIds: number[]; pinLength: 4 | 6; smsOptIn: boolean | null; askTexts: boolean;
}
export interface Location { id: number; name: string; kind: 'store' | 'office'; demo?: boolean; demoMode?: 'safe' | 'live' | null; email?: string | null; emailFrom?: string; emailReady?: boolean }
